const Joi = require("joi");

const committeeSchema = (data) => {
  const schema = Joi.object({
    committeeName: Joi.string()
      .trim()
      .max(60)
      //  .pattern(new RegExp("^[a-zA-Z0-9 ]*$"))
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Committee Name.",
        "string.empty": "Please enter Committee Name.",
        "any.required": "Please enter Committee Name.",
        "string.max": "Max length is 60",
      }),

    // committeeAdmin: Joi.string().trim().required().messages({
    //   "string.empty": "Please select Committee Chair.",
    //   "any.required": "Please select Committee Chair.",
    // }),

    // committeeAdmin: Joi.string().required().messages({
    //   "string.base": "Invalid Committee", // when it's not a string
    //   "any.required": "Committee is required.", // when no value selected
    //   "string.empty": "Please select a Committee Chair.", // when empty string is sent
    // }),

    committeeAdmin: Joi.array()
      // .items(Joi.array()) // each item should be a string (ID)
      .min(1) // at least one must be selected
      .required()
      .messages({
        "array.base": "Invalid Committee selection.", // if it's not an array
        "array.min": "Please select at least one Committee Chair.", // if empty
        "any.required": "Committee is required.", // if missing
        "string.base": "Committee IDs must be strings.", // if item not string
      }),

    // committeeAdmin: Joi.object({
    //   _id: Joi.string().required().messages({
    //     "string.empty": "Committee Admin ID is required",
    //     "any.required": "Committee Admin ID is required",
    //   }),
    //   firstName: Joi.string().trim().required().messages({
    //     "string.empty": "First Name is required",
    //     "any.required": "First Name is required",
    //   }),
    //   lastName: Joi.string().trim().required().messages({
    //     "string.empty": "Last Name is required",
    //     "any.required": "Last Name is required",
    //   }),
    //   fullName: Joi.string().trim().required().messages({
    //     "string.empty": "Full Name is required",
    //     "any.required": "Full Name is required",
    //   }),
    // })
    //   .required()
    //   .messages({
    //     "any.required": "Committee Admin is required.",
    //     "object.base": "Invalid Committee Admin object", // if not an object
    //   })
    //   .unknown(true),

    status: Joi.boolean().messages({
      "any.only": "Invalid access format.",
    }),

    secretCommittee: Joi.boolean().messages({
      "any.only": "Invalid access format.",
    }),

    // committeeDescription: Joi.string().trim().required().messages({
    //   "string.empty": "Please enter Committee Description.",
    //   "any.required": "Please enter Committee Description.",
    // }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = committeeSchema;
